<div
    class="flight-summary-icons"
    [popover]="summaryPopover"
    triggers="mouseenter:mouseleave"
    placement="bottom"
    container="body"
>
    <span class="flight-summary-icon-item">
        <i class="far fa-plane"></i> {{ totalFlights }}
    </span>
    <span class="flight-summary-icon-item">
        <i class="fal fa-map"></i> {{ flightsWithLogs }}
    </span>
    <span class="flight-summary-icon-item">
        <i class="far fa-stopwatch"></i> {{ timerFlights }}
    </span>
    <span class="flight-summary-icon-item">
        <i class="far fa-pencil"></i> {{ manualFlights }}
    </span>
    <span
        class="flight-summary-icon-item"
        *ngIf="hasFlightLogging && unassignedFlightLogsCount > 0"
    >
        <i class="far fa-link-slash"></i> {{ unassignedFlightLogsCount }}
    </span>
</div>

<ng-template #summaryPopover>
    <div class="flight-summary">
        <div class="flight-summary-row">
            <span>Total flights</span>
            <span>{{ totalFlights }}</span>
        </div>
        <div class="flight-summary-row">
            <span>Flights with logs</span>
            <span>{{ flightsWithLogs }}</span>
        </div>
        <div class="flight-summary-row">
            <span>FA timer flights</span>
            <span>{{ timerFlights }}</span>
        </div>
        <div class="flight-summary-row">
            <span>Manual flights</span>
            <span>{{ manualFlights }}</span>
        </div>
        <div
            class="flight-summary-row"
            *ngIf="hasFlightLogging && unassignedFlightLogsCount > 0"
        >
            <span>Unassigned flight logs</span>
            <span>{{ unassignedFlightLogsCount }}</span>
        </div>
    </div>
</ng-template>
